import React, { useContext, Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import DocumentsUploadComponent from 'tdic-capability-document-react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import cx from 'classnames';

import {
    Icon,
    ModalNextProvider,
    Loader,
    Link as DownloadLink
} from '@jutro/components';
import { error } from '@jutro/logger';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import { readViewModelValue } from 'gw-jutro-adapters-react';
import {
    TranslatorContext,
    IntlContext,
    withIntl
} from '@jutro/locale';

import { AgentService } from 'gw-capability-policy';
import { withDependencies } from 'gw-portals-dependency-react';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import { LobIconUtil, LocalDateUtil } from 'gw-portals-util-js';
import { messages as commonMessages } from 'gw-platform-translations';
import { ImageComponent } from 'gw-components-platform-react';
import { DataTable, DisplayColumn } from '@jutro/datatable';
import { documentMessages } from 'gw-capability-policy-common-react';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import ContactUtil from '../../utils/ClaimsDetailsUtil';
import ContactLinkComponent from '../../components/ContactLinkComponent/ContactLinkComponent';
import VendorLinkComponent from '../../components/VendorLinkComponent/VendorLinkComponent';
import metadata from './ClaimDetails.metadata.json5';
import claimDetailsStyles from './ClaimDetails.module.scss';
import messages from '../../Claims.messages';
import './ClaimDetails.messages';

class ClaimDetails extends Component {
    static propTypes = {
        location: PropTypes.shape({
            state: PropTypes.shape({
                summarystate: PropTypes.shape({}).isRequired
            }).isRequired
        }).isRequired,
        match: PropTypes.shape({
            url: PropTypes.string,
            params: PropTypes.shape({
                claimNumber: PropTypes.string
            })
        }).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func,
            goBack: PropTypes.func,
            location: PropTypes.shape({
                state: PropTypes.shape({})
            })
        }).isRequired,
        authHeader: PropTypes.shape({
            Authorization: PropTypes.string
        }).isRequired,
        ClaimService: PropTypes.shape({
            addRecentlyViewedClaim: PropTypes.func,
            claimsDocUploadToken: PropTypes.func,
            claimsRemoveDocument: PropTypes.func,
            getClaimDetail: PropTypes.func,
            uploadDocument: PropTypes.func,
            downloadDocumentLink: PropTypes.func
        }).isRequired,
        ClaimDownloadService: PropTypes.shape({
            getClaimDocument: PropTypes.func
        }).isRequired,
        intl: PropTypes.func.isRequired
    };

    static contextType = TranslatorContext;

    policyType = {
        BOP: 'BusinessOwners',
        WC: 'WC7WorkersComp',
        PA: 'PersonalAuto'
    }

    constructor(props) {
        super(props);
        this.getDocumentRemove = this.getDocumentRemove.bind(this);
    }

    state = {
        claimDetailsData: '',
        isClaimDetailsPageVisible: true,
        isLoading: true,
        coverage: 0,
        redirectPath: {},
        documentAlert: '',
        documentTypes: [],
        patientRecordDocType: [
            { displayName: 'Patient Record Related', code: 'insdstreatment_record_tdic' }
        ]
    };

    componentDidMount = () => {
        const {
            history: { location: state = {} }
        } = this.props;
        const redirectPathValues = state;
        this.setState({
            redirectPath: _.get(redirectPathValues, 'state.redirectPath') || '/claims'
        });
        this.getClaimDetailsResponse();
    };

    displayDocumentType = (item) => {
        switch (item) {
            case "INSD's Treatment Record":
                return 'Patient Related';
            case 'Letter':
                return 'Other';
            default:
                return '';
        }
    }

    newDocumentType = () => {
        const { documentTypes, patientRecordDocType } = this.state;
        const documentList = [];
        documentTypes.forEach((data) => {
            const display = {
                displayName: this.displayDocumentType(data.displayName),
                code: data.displayName
            };
            documentList.push(display);
        });
        const list = documentList.concat(patientRecordDocType);
        return _.orderBy(list, [(obj) => (obj.displayName)], ['desc']);
    }

    getClaimDetailsResponse = () => {
        const { ClaimService, authHeader, match } = this.props;
        ClaimService.getClaimDetail(match.params.claimNumber, authHeader)
            .then((claimResponse) => {
                const claimDetails = claimResponse;
                const translator = this.context;
                const pa = claimDetails.lobs.personalAuto;
                if (pa && pa.vehicleIncidents[0]) {
                    pa.vehicleIncidents[0].selected = true;
                }

                const responseData = {
                    claim: claimDetails,
                    claimPayments: claimDetails.checks,
                    claimServices: claimDetails.serviceRequests,
                    activities: claimDetails.activities || {},
                    reporter: this.getReportedByName(claimDetails, translator),
                    claimLosslocation: claimDetails.lossLocation,
                    selectedVehicleIncident:
                        pa && pa.vehicleIncidents[0] ? pa.vehicleIncidents[0] : {},
                    vehicles: this.getInvolvedVehicles(claimDetails),
                    claimContactsVendors: claimDetails.vendors,
                    claimHospitalsDays: claimDetails.hospitalDays,
                    claimContactsWithoutAgent: this.getPolicyTable(claimDetails)
                };
                this.setState({ documentTypes: _.get(claimDetails, 'documentTypes', []) });
                this.setState({
                    claimDetailsData: responseData,
                    isLoading: false
                });
            })
            .catch((err) => {
                error(`ClaimDetails: getClaimDetailsResponse - Unable to get claim data response ${JSON.stringify(err)}`);
                this.setState({ isLoading: false });
            });
        if (_.isFunction(ClaimService.addRecentlyViewedClaim)) {
            ClaimService.addRecentlyViewedClaim(match.params.claimNumber, authHeader);
        }
    };

    getCell = (item, index, { id: property }) => {
        return item[property];
    };

    getDataTableCell = (item, index, { path: property }) => {
        return item[property];
    };

    isContactTypeCheck = (contact, contactType) => {
        return ContactUtil.isInstanceOf(contact, contactType);
    };

    getContactTypePersonVisible = (item) => {
        return (this.isContactTypeCheck(item, 'Person') && !this.isContactTypeCheck(item, 'PersonVendor'));
    };

    getContactTypeVendorVisible = (item) => {
        return (this.isContactTypeCheck(item, 'CompanyVendor') || this.isContactTypeCheck(item, 'PersonVendor'));
    };

    getPartyNameLink = (item) => {
        const contactDTO = _.get(item, 'contactdetails');
        if (this.getContactTypeVendorVisible(item)) {
            const contact = { contactDTO };
            return <VendorLinkComponent id="vendorCell" vendors={[contact]} />;
        }
        return <ContactLinkComponent id="contactCell" contactDetails={contactDTO} />;
    };

    getRoleInvolvement = (claimContact) => {
        let roles = [];
        if (
            claimContact
            && claimContact.contactRolesDisplay
            && claimContact.contactRolesDisplay.length > 0
        ) {
            roles = claimContact.contactRolesDisplay;
        }
        return _.join(roles, ', ');
    };

    getPolicyTable = (claimDetailsData) => {
        const claimContactsWithoutAgent = _.filter(
            claimDetailsData.claimContacts,
            (claimContact) => {
                return claimContact.contactRoles.indexOf('agent') === -1;
            }
        ).map((claimContact) => {
            const roleInvolvement = this.getRoleInvolvement(claimContact);
            return {
                partyname: claimContact.contactDTO.displayName,
                involvement: roleInvolvement,
                primaryaddress: claimContact.contactDTO.primaryAddress,
                contactdetails: claimContact.contactDTO
            };
        });
        return claimContactsWithoutAgent;
    };

    getVehicleDetailsTable = (vehicles) => {
        return vehicles.map((vehicle) => {
            return {
                make: vehicle.make,
                model: vehicle.model,
                year: vehicle.year,
                license: vehicle.license,
                coverages: vehicle.coverages
            };
        });
    };

    getFormatCurrency = (deductible) => {
        let formattedAmount = '';
        if (deductible) {
            const { amount, currency } = deductible;
            if (amount && currency) {
                const intl = useContext(IntlContext);
                formattedAmount = intl.formatNumber(
                    amount,
                    {
                        style: 'currency',
                        currency: currency,
                        currencyDisplay: 'code'
                    }
                );
            }
        }
        return formattedAmount;
    };

    getLimitType = (coverage, translator) => {
        if (coverage.incidentLimit && coverage.exposureLimit) {
            return (
                <div>
                    <p>{translator(messages.perAccident)}</p>
                    <p>{translator(messages.perPerson)}</p>
                </div>
            );
        }
        if (coverage.incidentLimit) {
            return translator(messages.perAccident);
        }
        if (coverage.exposureLimit) {
            return translator(messages.perPerson);
        }
        return '-';
    };

    handleError = (title, message) => {
        return ModalNextProvider.showAlert({
            title: title,
            message: message,
            status: 'error',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.ok
        }).catch(_.noop);
    };

    getLimitValue = (coverage) => {
        if (coverage.incidentLimit && coverage.exposureLimit) {
            return (
                <div>
                    <p>{this.getFormatCurrency(coverage.incidentLimit)}</p>
                    <p>{this.getFormatCurrency(coverage.exposureLimit)}</p>
                </div>
            );
        }
        if (coverage.incidentLimit) {
            return this.getFormatCurrency(coverage.incidentLimit);
        }
        if (coverage.exposureLimit) {
            return this.getFormatCurrency(coverage.exposureLimit);
        }
        return '-';
    };

    getVehicleCoverageTable = (coverages, translator) => {
        return coverages.map((coverage) => {
            const limitValue = this.getLimitValue(coverage);
            const limitType = this.getLimitType(coverage, translator);
            const deductibleAmount = coverage.deductible
                ? this.getFormatCurrency(coverage.deductible)
                : '';
            return {
                type: coverage.name,
                deductible: deductibleAmount,
                limittype: limitType,
                limitvalue: limitValue
            };
        });
    };

    getBackToPreviousState = () => {
        const { history } = this.props;
        const { redirectPath } = this.state;
        const redirectpath = {
            pathname: redirectPath,
            state: 'claims'
        };
        history.push(redirectpath);
    };

    getClaimNumber = (claimDetailsData, translator) => {
        return translator(messages.claimDetailNumber,
            { num: claimDetailsData.claimNumber });
    };

    getPolicyNumber = (claimDetailsData) => {
        const redirectPath = `/policies/${claimDetailsData.policy.policyNumber}/summary`;
        if (appConfig.persona === 'policyholder') {
            return claimDetailsData.policy.policyNumber;
        }
        return (
            <Link to={redirectPath} className={claimDetailsStyles.gwClaimDetailsLink}>
                {claimDetailsData.policy.policyNumber}
            </Link>
        );
    };

    getAccountNumber = (claimDetailsData) => {
        const redirectPath = `/accounts/${claimDetailsData.policy.accountNumber}/summary`;
        if (appConfig.persona === 'policyholder') {
            return claimDetailsData.policy.accountNumber;
        }
        return (
            <Link to={redirectPath} className={claimDetailsStyles.gwClaimDetailsLink}>
                {claimDetailsData.policy.accountNumber}
            </Link>
        );
    };

    getLossDate = (claimDetailsData, intl) => {
        return intl.formatDate(new Date(claimDetailsData.lossDate), { year: 'numeric', month: 'short', day: 'numeric' });
    }

    getReportedByName = (claimDetailsData, translator) => {
        if (claimDetailsData.claimReporter.reportedBy.displayName) {
            return claimDetailsData.claimReporter.reportedBy.displayName;
        }
        return translator(messages.unknown);
    };

    getPrimaryContactName = (claimDetailsData) => {
        if (claimDetailsData.mainContact && claimDetailsData.mainContact.displayName) {
            return claimDetailsData.mainContact.displayName;
        }
        return '';
    };

    getAdjusterName = (claimDetailsData, translator) => {
        if (claimDetailsData.adjuster.displayName) {
            return claimDetailsData.adjuster.displayName;
        }
        return translator(messages.unknown);
    };

    getInjuredParty = (claimDetailsData) => {
        const { claimDetailsData: { claim: { claimContacts } } } = this.state;
        const injuredContact = _.find(claimContacts, (contact) => {
            if (claimDetailsData.claim.policy.policyType === this.policyType.WC) {
                return _.includes(contact.contactRoles, 'claimant');
            }
            return _.includes(contact.contactRoles, 'injured');
        });
        return !_.isEmpty(injuredContact) ? injuredContact.contactDTO.displayName : '';
    };

    toggleVehicleDetailsContainer = (claimDetailsData) => {
        if (
            claimDetailsData.claim.policy.policyType === this.policyType.PA
            && claimDetailsData.vehicles.length > 0
        ) {
            return true;
        }
        return false;
    };

    getCoverageForSelectedVehicle = (claimDetailsData, translator) => {
        const { coverage } = this.state;
        const selectedVehicle = this.getInvolvedVehicles(claimDetailsData);
        if (!_.isEmpty(selectedVehicle)) {
            return translator(
                messages.coveragesFor,
                {
                    vehicleMake: selectedVehicle[coverage].make,
                    vehicleModel: selectedVehicle[coverage].model
                }
            );
        }
        return '';
    };

    getLossLocation = (claimDetailsData) => {
        let location = '';
        if (claimDetailsData.lossLocation && claimDetailsData.lossLocation.displayName) {
            location = claimDetailsData.lossLocation.displayName;
            location.replace('\n', ', ');
        }
        return location;
    };

    getLossLocationVisibility = (claimDetailsData) => {
        if (claimDetailsData.lossLocation && claimDetailsData.lossLocation.displayName) {
            return true;
        }
        return false;
    };

    getEmployerNotifiedVisibility = (claimDetailsData) => {
        if (claimDetailsData.lossType === 'WC7') {
            return true;
        }
        return false;
    };

    getEmployerNotifiedDate = (claimDetailsData, intl) => {
        let employernotifiedDate;
        if ((claimDetailsData.lossType === 'WC7') && (claimDetailsData.lobs.wc7workersComp_Ext.dateReportedToEmployer)) {
            employernotifiedDate = intl.formatDate(
                new Date(claimDetailsData.lobs.wc7workersComp_Ext.dateReportedToEmployer),
                { year: 'numeric', month: 'short', day: 'numeric' }
            );
        }
        return employernotifiedDate;
    };

    getHospitalDaysVisibility = (claimDetailsData) => {
        if (claimDetailsData.hospitalDays) {
            return true;
        }
        return false;
    };

    getInvolvedVehicles = (claimDetails) => {
        let involvedVehicles = [];
        const pa = claimDetails.lobs.personalAuto;
        const papolicy = claimDetails.policy.lobs.personalAuto;
        if (!pa) {
            return [];
        }
        if (
            pa.vehicleIncidents === null
            || pa.vehicleIncidents.length < 1
            || claimDetails.policy === null
            || papolicy.vehicles === null
        ) {
            return involvedVehicles;
        }

        const involvedVINarray = pa.vehicleIncidents.map((item) => {
            return item.vehicle.vIN;
        });
        involvedVehicles = _.filter(papolicy.vehicles, (vehicle) => {
            return involvedVINarray.indexOf(vehicle.vIN) !== -1;
        }).map((vehicle) => {
            return vehicle;
        });
        return involvedVehicles;
    };

    getSelectedVehicleCoverages = (claimDetails) => {
        const { coverage } = this.state;
        const selectedVehicle = this.getInvolvedVehicles(claimDetails);
        if (!_.isEmpty(selectedVehicle)) {
            return selectedVehicle[coverage].coverages;
        }
        return '';
    };

    getDataCell = (item, index, { path: property }) => {
        const translator = this.context;
        let toolTipMessage = '';
        switch (property) {
            case 'documentName':
                toolTipMessage = translator(messages.documentsName);
                break;
            case 'documentDate':
                toolTipMessage = translator(messages.documentsDateModified);
                break;
            case 'documentType':
                toolTipMessage = translator(messages.documentType);
                break;
            default:
                toolTipMessage = '';
        }
        return (
            <span title={toolTipMessage} className={property === 'documentDate' ? claimDetailsStyles.docCreated : undefined}>
                {item[property]}
            </span>
        );
    };

    onViewDownloadClicked = (event, document) => {
        event.preventDefault();
        const { ClaimService } = this.props;
        const { documentviewdownload: { publicID, sessionID } } = document;
        ClaimService.downloadDocumentLink(publicID, sessionID)
            .then((response) => {
                if (response.ok) {
                    response.text().then((text) => {
                        const docWin = window.open('', '_blank');
                        docWin.document.write(text);
                    });
                } else {
                    ModalNextProvider.showAlert({
                        title: messages.viewDownload,
                        message: messages.downloadErrorMessage,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok
                    }).then(_.noop);
                }
            });
    };

    getViewandDownload = (item) => {
        const translator = this.context;
        return (
            <DownloadLink
                href="/"
                onClick={(event) => this.onViewDownloadClicked(event, item)}
                target="_blank"
                key={item.documentviewdownload}
                className={claimDetailsStyles.documentIcon}
                title={translator(messages.documentsViewandDownload)}
            >
                <Icon icon="mi-insert_drive_file" />
            </DownloadLink>
        );
    };

    getDocumentRemove = (item) => {
        const translator = this.context;
        const { authHeader, ClaimService } = this.props;
        const { claimDetailsData } = this.state;
        const { Authorization } = authHeader;
        const { documentremove } = item;
        const {
            claimNumber, publicID, name, canDelete
        } = documentremove;
        this.setState({ documentAlert: '' });
        if (!canDelete) {
            const alertMsg = translator(messages.unableToDeleteClaims, { documentName: name });
            this.setState({ documentAlert: alertMsg });
            return;
        }
        ModalNextProvider.showConfirm({
            title: messages.confirmationToRemoveTitle,
            message: translator(messages.confirmationToRemoveMessage, { documentname: name }),
            status: 'warning',
            icon: 'mi-error-outline',
            confirmButtonText: messages.removeConfirmationYes,
            cancelButtonText: messages.removeConfirmationNo
        }).then(async (results) => {
            if (results === 'cancel') {
                return _.noop();
            }
            try {
                const isDeleteItem = await ClaimService.claimsRemoveDocument(
                    [claimNumber, publicID],
                    { Authorization: Authorization }
                );
                if (isDeleteItem === false) {
                    return this.handleError(
                        messages.deletionFailedTitle,
                        messages.deletionFailedMessage
                    );
                }
                claimDetailsData.claim.documents = _.filter(
                    claimDetailsData.claim.documents,
                    (doc) => {
                        return doc.publicID !== publicID;
                    }
                );
                return this.setState({
                    claimDetailsData: claimDetailsData
                });
            } catch (e) {
                error(`ClaimDetails: getDocumentRemove - Unable to remove document ${JSON.stringify(e)}`);
                return this.handleError(
                    messages.removeServiceFailedTitle,
                    messages.removeServiceFailedMessage
                );
            }
        }, _.noop);
    };

    formatAMPM = (date) => {
        let hours = date.getHours() % 12;
        let minutes = date.getMinutes();
        const ampm = date.getHours() >= 12 ? 'PM' : 'AM';
        hours = hours || 12;
        minutes = minutes < 10 ? `0${minutes}` : minutes;
        const strTime = `${hours}:${minutes} ${ampm}`;
        return strTime;
    };

    getDocumentsArray = (documents, intl) => {
        return documents.map((doc) => {
            const docDate = intl.formatDate(new Date(doc.dateModified), { year: 'numeric', month: 'short', day: 'numeric' });
            return {
                documentName: doc.name,
                documentDate: `${docDate} ${this.formatAMPM(new Date(doc.dateModified))}`,
                documentviewdownload: doc,
                documentremove: doc,
                documentType: doc.documentTypeDisplayName
            };
        });
    };

    showServiceVendorAddress = (serviceData) => {
        const contactDTO = serviceData.vendor || serviceData;
        const vendor = { contactDTO };
        return <VendorLinkComponent id="vendorCell" vendors={[vendor]} />;
    };

    getVendorNameLink = (item) => {
        return <VendorLinkComponent id="vendorCell" vendors={[item]} />;
    };

    expanderContent = (data) => {
        const translator = this.context;
        const coverageArray = this.getVehicleCoverageTable(data.coverages, translator);
        const coveragesForVehicleHeader = translator(
            messages.coveragesFor,
            {
                vehicleMake: data.make,
                vehicleModel: data.model
            }
        );
        return (
            <>
                <h4>{coveragesForVehicleHeader}</h4>
                <DataTable
                    data={coverageArray}
                    id="vehicleCoverageTableId"
                    title={coveragesForVehicleHeader}
                    titleId="vehicleCoverageTitleId"
                    titlePosition="left"
                    expandable={false}
                    showSearch={false}
                    showPagination={false}
                >
                    <DisplayColumn
                        cell={(row) => row.type}
                        columnProportion={1}
                        header={translator(messages.type)}
                        id="typeHeader"
                        textAlign="left"
                    />
                    <DisplayColumn
                        cell={(row) => row.deductible}
                        columnProportion={1}
                        header={translator(messages.deductible)}
                        id="deductibleHeader"
                        textAlign="left"
                    />
                    <DisplayColumn
                        cell={(row) => row.limittype}
                        columnProportion={1}
                        header={translator(messages.limittype)}
                        id="limitTypeHead"
                        textAlign="left"
                    />
                    <DisplayColumn
                        cell={(row) => row.limitvalue}
                        columnProportion={1}
                        header={translator(messages.limitvalue)}
                        id="limitValueHead"
                        textAlign="left"
                    />
                </DataTable>
            </>
        );
    };

    formatPaymentDate = (claimPaymentDate, intl) => {
        return claimPaymentDate !== undefined ? intl.formatDate(
            new Date(claimPaymentDate), { year: 'numeric', month: 'short', day: 'numeric' }
        ) : ' ';
    }

    getPaymentGrossAmount = (paymentGrossAmount) => {
        let grossAmount;
        const { amount, currency } = paymentGrossAmount;
        if (amount && currency) {
            const intl = useContext(IntlContext);
            grossAmount = intl.formatNumber(
                amount,
                {
                    style: 'currency',
                    currency: currency,
                    currencyDisplay: 'code'
                }
            );
        }
        return `${grossAmount}`;
    };

    getPaymentCheckNumber = (paymentCheckNumber) => {
        return paymentCheckNumber !== undefined ? paymentCheckNumber : ' ';
    };

    generatePaymentDetailsOverrides = (intl) => {
        const { claimDetailsData } = this.state;
        const translator = this.context;

        const paymentChecksPath = 'claimPayments';
        const paymentChecks = _.get(claimDetailsData, paymentChecksPath, []);
        const overrides = paymentChecks.map((paymentCheck, index) => {
            return {
                [`paymentScheduledDate${index}`]: {
                    value: this.formatPaymentDate(paymentCheck.scheduledDate, intl)
                },
                [`paymentIssueDate${index}`]: {
                    value: this.formatPaymentDate(paymentCheck.issueDate, intl)
                },
                [`paymentStatus${index}`]: {
                    value: translator({
                        id: `typekey.TransactionStatus.${paymentCheck.status}`,
                        defaultMessage: paymentCheck.status
                    })
                },
                [`paymentCheckNumber${index}`]: {
                    value: this.getPaymentCheckNumber(paymentCheck.checkNumber)
                },
                [`paymentPayee${index}`]: {
                    value: paymentCheck.payee.join(', ')
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    checkPaymentsHasDetails = () => {
        const { claimDetailsData } = this.state;
        return claimDetailsData.claim.checks && claimDetailsData.claim.checks.length > 0;
    };

    mapServiceStatus = (status) => {
        const translator = this.context;
        switch (status) {
            case 'workcomplete':
                return translator(messages.statusCompleted);
            case 'specialistwaiting':
            case 'requested':
            case 'inprogress':
            case 'draft':
                return translator(messages.statusInProgress);
            case 'expired':
            case 'declined':
            case 'canceled':
                return translator(messages.statusOffTrack);
            default:
                return translator(messages.statusUnknown);
        }
    };

    changeStatusIcon = (status) => {
        switch (status) {
            case 'workcomplete':
                return 'check';
            case 'specialistwaiting':
            case 'requested':
            case 'inprogress':
            case 'draft':
                return 'refresh';
            case 'expired':
            case 'declined':
            case 'canceled':
                return 'times';
            default:
                return ' ';
        }
    };

    showServiceCompletionDate = (serviceRequest) => {
        const translator = this.context;
        const checkServiceStatus = false;
        const serviceStatus = this.mapServiceStatus(serviceRequest.status);
        if (
            serviceStatus === translator(messages.statusInProgress)
            && serviceRequest.expectedServiceCompletionDate
        ) {
            return !checkServiceStatus;
        }
        return checkServiceStatus;
    };

    getServicePrimaryContact = (serviceRequest) => {
        const serviceContactRoles = `(${serviceRequest.customerClaimContact.contactRolesDisplay.join(
            ', '
        )})`;
        return (
            <>
                <ContactLinkComponent
                    contactDetails={serviceRequest.customerClaimContact.contactDTO}
                />
                <span>{serviceContactRoles}</span>
            </>
        );
    };

    generateServiceDetailsOverrides = (intl) => {
        const { claimDetailsData } = this.state;
        const serviceRequestsPath = 'claimServices';
        const serviceRequests = _.get(claimDetailsData, serviceRequestsPath, []);
        const overrides = serviceRequests.map((serviceRequest, index) => {
            return {
                [`serviceCompletionDate${index}`]: {
                    value: intl.formatDate(
                        new Date(serviceRequest.expectedServiceCompletionDate),
                        { year: 'numeric', month: 'short', day: 'numeric' }
                    ),
                    visible: this.showServiceCompletionDate(serviceRequest),
                },
                [`serviceStatusIcon${index}`]: {
                    icon: this.changeStatusIcon(serviceRequest.status)
                },
                [`serviceVendorLink${index}`]: {
                    value: this.showServiceVendorAddress(serviceRequest),
                },
                [`serviceStatus${index}`]: {
                    value: this.mapServiceStatus(serviceRequest.status)
                },
                [`servicePrimaryContact${index}`]: {
                    value: this.getServicePrimaryContact(serviceRequest),
                    visible:
                        appConfig.persona === 'producer'
                        || _.get(claimDetailsData, 'claim.policy.policyType', '') === 'WorkersComp'
                },
                [`serviceItems${index}`]: {
                    value: serviceRequest.services.join(', ')
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    checkServiceRequestsHasDetails = () => {
        const { claimDetailsData } = this.state;
        return (claimDetailsData.claim.serviceRequests
            && claimDetailsData.claim.serviceRequests.length > 0);
    };

    canAccessFinancials = () => {
        return appConfig.persona === 'producer' || appConfig.persona === 'csr';
    };

    handleError = (err) => {
        error(`ClaimsDetails: handleError - Unable to handle the error ${err}`);
        return (ModalNextProvider.showAlert({
            title: documentMessages.documentUploadFailed,
            message: documentMessages.documentCannotUploaded,
            status: 'error',
            confirmButtonText: commonMessages.ok
        }));
    };

    getProductImage = () => {
        const { claimDetailsData } = this.state;
        let offeringCode = _.get(claimDetailsData, 'claim.policy.offeringCode_Ext');
        const offeringName = _.get(claimDetailsData, 'claim.policy.offeringName_Ext');
        if (_.isUndefined(offeringCode)) {
            offeringCode = _.get(claimDetailsData, 'claim.policy.policyType');
        }
        return (
            <ImageComponent
                src={`/branding/${LobIconUtil.getImageIcon(offeringCode, offeringName)}.svg`}
                alt={offeringCode}
                title={offeringName}
            />
        );
    };

    // eslint-disable-next-line consistent-return
    handleDocumentsUpload = async (fileData, docType, docDesc) => {
        const {
            match
        } = this.props;
        const { claimDetailsData, patientRecordDocType } = this.state;
        const namedInsured = claimDetailsData.claim.claimContacts.find((item) => {
            return item.contactRolesDisplay.includes('Insured');
        });
        const policyNumber = _.get(claimDetailsData, 'claim.policy.policyNumber', '');
        const state = _.get(claimDetailsData, 'claimLosslocation.state', '');
        const policyType = (_.get(claimDetailsData, 'claim.policy.policyType') === this.policyType.WC) ? _.get(claimDetailsData, 'claim.policy.offeringCodeWC_Ext', '')
            : _.get(claimDetailsData, 'claim.policy.offeringCode_Ext', '');
        const reportedBy = _.get(claimDetailsData, 'reporter', '');
        const zipCode = _.get(namedInsured, 'contactDTO.primaryAddress.postalCode', '');
        const primaryNameInsured = _.get(claimDetailsData, 'claim.policy.insured_Ext', '');
        const [additionalDocType] = patientRecordDocType;

        const { authHeader } = this.props;

        const documentMetaDataTemplate = {
            mimeType: fileData.type,
            documentName: fileData.name,
            typeOfDocument: additionalDocType.code === docType
                ? additionalDocType.displayName : this.displayDocumentType(docType),
            description: docDesc,
            policyNumber: policyNumber,
            policyType: policyType,
            claimNumber: match.params.claimNumber,
            policyHolder: primaryNameInsured,
            requestedBy: reportedBy,
            dateUploaded: LocalDateUtil.today(),
            state: state,
            zipCode: zipCode.substring(0, 5)
        };
        try {
            AgentService.sendUploadDocumentOnClaimEmailToAgent(
                fileData,
                documentMetaDataTemplate,
                authHeader
            ).then((documentsData) => {
                if (documentsData) {
                    return (ModalNextProvider.showAlert({
                        title: documentMessages.documentUploadedTitle,
                        message: documentMessages.documentUploaded,
                        status: 'error',
                        confirmButtonText: commonMessages.ok
                    }).catch(_.noop));
                }
                return this.handleError();
            });
        } catch (err) {
            error(`ClaimDetails: handleDocumentsUpload - Unable to handle document upload ${JSON.stringify(err)}`);
            return this
                .handleError(commonMessages.errorUploadTitle, commonMessages.uploadFailedMessage);
        }
    };

    render() {
        const { intl, location: { state } } = this.props;
        const selectedTab = _.get(state, 'selectedTab', 'summaryTab');
        const {
            claimDetailsData,
            isClaimDetailsPageVisible,
            isLoading,
            documentAlert,
        } = this.state;
        const translator = this.context;
        if (isLoading) {
            return <Loader loaded={!isLoading} />;
        }

        if (!claimDetailsData) {
            return null;
        }

        const policyArray = this.getPolicyTable(claimDetailsData.claim);
        let vehicleDetailsArray = [];
        let documentsArray = [];
        if (claimDetailsData.claim.documents.length > 0) {
            documentsArray = this.getDocumentsArray(claimDetailsData.claim.documents, intl);
        }
        if (this.toggleVehicleDetailsContainer(claimDetailsData)) {
            vehicleDetailsArray = this.getVehicleDetailsTable(claimDetailsData.vehicles);
        }
        const overrides = {
            partiesInvolvedTableGrid: {
                data: policyArray
            },
            vendorInvolvedTableGrid: {
                data: claimDetailsData.claimContactsVendors
            },
            vehicleDetailsDataTable: {
                data: vehicleDetailsArray,
                expanderContent: this.expanderContent,
                visible: vehicleDetailsArray.length > 0
            },
            claimStatus: {
                value: translator({
                    id: `typekey.ClaimState.${claimDetailsData.claim.claimState}`,
                    defaultMessage: claimDetailsData.claim.claimState
                })
            },
            documentsTableGrid: {
                data: _.sortBy(documentsArray, 'dateModified').reverse(),
                placeholder: _.isEmpty(documentsArray) && translator(messages.noDocumentFound)
            },
            removeDocumentNotification: {
                message: documentAlert,
                visible: !_.isEmpty(documentAlert)
            },
            primaryContact: {
                visible: !!this.getPrimaryContactName(claimDetailsData.claim),
                value: this.getPrimaryContactName(claimDetailsData.claim)
            },
            claimDetailNumber: {
                content: this.getClaimNumber(claimDetailsData.claim, translator)
            },
            policyNumber: {
                value: this.getPolicyNumber(claimDetailsData.claim)
            },
            accountNumber: {
                value: this.getAccountNumber(claimDetailsData.claim)
            },
            lossLocation: {
                visible: this.getLossLocationVisibility(claimDetailsData.claim),
                value: this.getLossLocation(claimDetailsData.claim)
            },
            employerNotified: {
                visible: this.getEmployerNotifiedVisibility(claimDetailsData.claim),
                value: this.getEmployerNotifiedDate(claimDetailsData.claim, intl)
            },
            daysInHospital: {
                visible: this.getHospitalDaysVisibility(claimDetailsData.claim)
            },
            dateOfLoss: {
                value: this.getLossDate(claimDetailsData.claim, intl)
            },
            adjusterName: {
                value: this.getAdjusterName(claimDetailsData.claim, translator)
            },
            vehicleDetailsContainer: {
                visible:
                ['producer', 'csr', 'policyholder'].includes(appConfig.persona)
                    && this.toggleVehicleDetailsContainer(claimDetailsData)
            },
            noClaimPaymentsDetails: {
                visible: !this.checkPaymentsHasDetails()
            },
            claimPaymentsDetails: {
                visible: this.checkPaymentsHasDetails()
            },
            noClaimServicesDetails: {
                visible: !this.checkServiceRequestsHasDetails()
            },
            claimServicesDetails: {
                visible: this.checkServiceRequestsHasDetails()
            },
            claimDetailsPage: {
                visible: isClaimDetailsPageVisible
            },
            summaryRightDiv: {
                visible: this.canAccessFinancials()
            },
            partyTableContainer: {
                visible: ['producer', 'vendor', 'csr'].includes(appConfig.persona)
            },
            claimDetailsTabset: {
                defaultActiveTab: selectedTab
            },
            vendorTableContainer: {
                visible: appConfig.persona === 'policyholder'
            },
            documentscomponent: {
                docTypeList: this.newDocumentType()
            },
            claimDetailsIcon: {
                content: this.getProductImage()
            },
            injuredParty: {
                value: this.getInjuredParty(claimDetailsData),
                visible: claimDetailsData.claim.policy.policyType !== this.policyType.BOP
            },
            medicalAmount: {
                visible: claimDetailsData.claim.policy.policyType === this.policyType.WC
            },
            ...this.generatePaymentDetailsOverrides(intl),
            ...this.generateServiceDetailsOverrides(intl)
        };
        const resolvers = {
            resolveCallbackMap: {
                getBackToPreviousState: this.getBackToPreviousState,
                getCell: this.getCell,
                getDataCell: this.getDataCell,
                getLimitType: this.getLimitType,
                getPartyNameLink: this.getPartyNameLink,
                getVendorNameLink: this.getVendorNameLink,
                getViewandDownload: this.getViewandDownload,
                handleDocumentsUpload: this.handleDocumentsUpload,
                onRowClick: (data) => {
                    _.set(data, 'expanded', !data.expanded);
                }
            },
            resolveClassNameMap: claimDetailsStyles,
            resolveComponentMap: {
                documentscomponent: DocumentsUploadComponent
            },
        };

        const readValue = (id, path) => {
            return readViewModelValue(metadata.pageContent, claimDetailsData, id, path, overrides);
        };

        const claimDetailsPage = (
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimDetailsData}
                overrideProps={overrides}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
            />
        );

        return <div className={cx(claimDetailsStyles.claimDetails)}>{claimDetailsPage}</div>;
    }
}

export const ClaimDetailsComponent = ClaimDetails;
export default withRouter(
    withIntl(withAuthenticationContext(withDependencies(['ClaimService', 'ClaimDownloadService'])(ClaimDetails)))
);
